"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialProviderSlug = exports.SOCIAL_PROVIDER_SLUGS = exports.SOCIAL_PROVIDERS = void 0;
// 소셜 로그인 provider (api·web 공통)
// role(ROLES) 과 동일하게 Prisma enum 이 아닌 문자열 상수로 관리한다.
// provider 를 추가할 때 여기 한 곳만 수정하면 되고 DB 마이그레이션이 필요 없다.
exports.SOCIAL_PROVIDERS = {
    KAKAO: "KAKAO",
    NAVER: "NAVER",
    DISCORD: "DISCORD",
};
// 라우트 파라미터(소문자)와 저장/식별용 상수(대문자) 사이 변환 헬퍼.
// 예: URL 은 /v1/auth/kakao, DB provider 는 "KAKAO".
exports.SOCIAL_PROVIDER_SLUGS = {
    kakao: exports.SOCIAL_PROVIDERS.KAKAO,
    naver: exports.SOCIAL_PROVIDERS.NAVER,
    discord: exports.SOCIAL_PROVIDERS.DISCORD,
};
const isSocialProviderSlug = (value) => value in exports.SOCIAL_PROVIDER_SLUGS;
exports.isSocialProviderSlug = isSocialProviderSlug;
